<template>
  <v-container fluid>
    <!-- sidebar -->
    <sidebar-menu :drawer="drawer" />

    <!-- Sidebar SubMenu -->
    <sidebar-submenu />

    <!-- topbar -->
    <app-topbar :drawer="drawer" @click="drawer = !drawer" />

    <!-- content area -->
    <content-area />

    <!-- Footer -->
    <app-footer />
  </v-container>
</template>

<script>
import sidebarMenuVue from './SidebarMenu.vue'
import sidebarSubMenuVue from './SidebarSubMenu.vue'
import contentAreaVue from './contentArea.vue'
import AppTopbarVue from '../_partials/AppTopbar.vue'
import AppFooterVue from '../_partials/AppFooter.vue'

export default {
  name: 'Dashboard',

  components: {
    sidebarMenu: sidebarMenuVue,
    sidebarSubmenu: sidebarSubMenuVue,
    contentArea: contentAreaVue,
    appTopbar: AppTopbarVue,
    appFooter: AppFooterVue
  },

  data: () => ({
    drawer: true,
    clipped: false,
    fixed: false,
    miniVariant: true,
    right: true,
    rightDrawer: false
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding: 0;
  margin: 0;
}

#footer {
  background: rgba(10, 18, 27, 0.95);
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
